<template>
  <div class="download-potential-background">
    <div class="download-potential-banner">
      <div class="download-potential-container">
        <div class="download-potential-banner-title">{{ $t("potential.banner") }}</div>
      </div>

      <img class="download-potential-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="download-potential-container">

     <div class="download-potential-content">
       <div class="download-potential-content-title">
         <div class="download-potential-content-title-text">{{ $t("potential.title") }}</div>
         <div class="download-potential-line"></div>
       </div>
       <div class="download-potential-content-info">
         <p class="download-potential-content-info-text">{{ $t("potential.titleP1") }}<a class="download-potential-a" target="_blank" href="http://www.quantum-espresso.org/pseudopotentials/unified-pseudopotential-format">Quantum Espresso</a>{{ $t("potential.titleP1_2") }}</p>
         <p class="download-potential-content-info-text">{{ $t("potential.titleP2") }}<a class="download-potential-a" target="_blank" href="http://www.quantum-simulation.org/potentials/sg15_oncv/index.htm">SG15</a>{{ $t("potential.titleP2_2") }}<a class="download-potential-a" target="_blank" href="http://www.pseudo-dojo.org/index.html">PD03</a>{{ $t("potential.titleP2_2") }}<a class="download-potential-a" target="_blank" href="https://th.fhi-berlin.mpg.de/th/fhi98md/fhi98PP/">FHI</a>{{ $t("potential.titleP2_4") }}<a class="download-potential-a" target="_blank" href="http://www.mat-simresearch.com/">ONCVPSP</a>{{ $t("potential.titleP2_5") }}</p>
         <p class="download-potential-content-info-text">{{ $t("potential.titleP3") }}<a class="download-potential-a" target="_blank" href="http://www.physics.rutgers.edu/gbrv/">GBRV</a>{{ $t("potential.titleP3_2") }}</p>
         <p class="download-potential-content-info-text">{{ $t("potential.titleP4") }}Reproducibility in density functional theory calculations of solids.K. Lejaeghere et. all, Science 25 Mar 2016, Vol. 351, Issue 6280,10.1126/science.aad3000。</p>
         <p class="download-potential-content-info-text">{{ $t("potential.titleP5") }}</p>
         <p class="download-potential-content-info-text">{{ $t("potential.titleP6") }}<a class="download-potential-a" target="_blank" href="https://github.com/cp2k/cp2k/tree/master/data">cp2k</a>{{ $t("potential.titleP6_2") }}</p>
       </div>

       <div class="download-potential-content-title">
         <div class="download-potential-content-title-text">{{ $t("potential.part2") }}</div>
         <div class="download-potential-line"></div>
       </div>
       <div class="download-potential-download-border">

         <div class="download-potential-download-content" v-for="file in potentialDownload">
           <div ><a class="download-potential-download-text" :href='PSEDUO_DOWNLOAD+file.name'>{{file.name}}</a></div>
           <div class="download-potential-content-info-text" v-show="file.summary">{{file.summary}}</div>
         </div>

       </div>

       <div class="download-potential-content-title">
         <div class="download-potential-content-title-text">{{ $t("potential.part3") }}</div>
         <div class="download-potential-line"></div>
       </div>
       <div class="download-potential-content-info">
         <p class="download-potential-content-info-text">{{ $t("potential.part3P1") }}</p>
         <p class="download-potential-content-info-text">{{ $t("potential.part3P2") }}</p>
         <p class="download-potential-content-info-text">{{ $t("potential.part3P3") }}</p>
         <p class="download-potential-content-info-text">{{ $t("potential.part3P4") }}</p>
         <p class="download-potential-content-info-text">{{ $t("potential.part3P5") }}</p>
         <p class="download-potential-content-info-text">{{ $t("potential.part3P6") }}</p>
         <p class="download-potential-content-info-text">{{ $t("potential.part3P7") }}</p>

         <div class="download-potential-config-background">
           <p class="download-potential-config-text">109 --- H_0.25.SG15.PBE.UPF</p>
           <p class="download-potential-config-text">110 --- H_0.33.SG15.PBE.UPF</p>
           <p class="download-potential-config-text">111 --- H_0.42.SG15.PBE.UPF</p>
           <p class="download-potential-config-text">112 --- H_0.50.SG15.PBE.UPF</p>
           <p class="download-potential-config-text">113 --- H_0.58.SG15.PBE.UPF</p>
           <p class="download-potential-config-text">114 --- H_0.66.SG15.PBE.UPF</p>
           <p class="download-potential-config-text">115 --- H_0.75.SG15.PBE.UPF</p>
           <p class="download-potential-config-text">116 --- H_1.25.SG15.PBE.UPF</p>
           <p class="download-potential-config-text">117 --- H_1.33.SG15.PBE.UPF</p>
           <p class="download-potential-config-text">118 --- H_1.50.SG15.PBE.UPF</p>
           <p class="download-potential-config-text">119 --- H_1.66.SG15.PBE.UPF</p>
           <p class="download-potential-config-text">120 --- H_1.75.SG15.PBE.UPF</p>
           <p class="download-potential-config-text">121 --- H_0.17.SG15.PBE.UPF</p>
         </div>
         <p class="download-potential-content-info-text">{{ $t("potential.part3P8") }}</p>

       </div>



     </div>
    </div>
  </div>
</template>

<script>
  import {PSEDUO_DOWNLOAD} from "../../helpers/consts"
  import {potentialDownload} from "../../helpers/potentialDownload"

  export default {
    name: "companyIntroduce",
    data(){
      return {
        PSEDUO_DOWNLOAD,
        potentialDownload
      }
    },
  }
</script>

<style scoped>
  .download-potential-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .download-potential-background{
    margin-top: 70px;
  }
  .download-potential-banner{
    overflow:hidden;
  }
  .download-potential-banner-title{
    font-size:24px;
    font-family:PingFangSC-Semibold,sans-serif;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:50px;
    position: absolute;
    margin-top: 60px;
  }
  .download-potential-banner-img{
    min-width:100%;
    height:165px;
  }
  .download-potential-content{
    margin-top: 30px;
    margin-bottom: 90px;
  }
  .download-potential-content-title{
    padding-top: 50px;
  }
  .download-potential-content-title-text{
    font-size:30px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(73,145,201,1);
    line-height:50px;
  }
  .download-potential-content-info{
    margin-top: 40px;
  }
  .download-potential-content-info-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .download-potential-content-info-text-update{
    color:rgba(73,145,201,1);
    margin-top: 24px;
  }
  .download-potential-line{
    height:1px;
    background:rgba(240,240,240,1);
    margin-top: 8px;
  }
  .download-potential-a{
    color:rgba(73,145,201,1);
  }
  .download-potential-config-background{
    background:rgba(73,145,201,0.1);
    padding: 24px;
    margin-top: 32px;
    margin-bottom: 32px;
  }
  .download-potential-config-text{
    font-size:14px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:18px;
  }
  .download-potential-download-border{
    background:rgba(236,244,249,1);
    padding: 24px 32px;
  }
  .download-potential-download-text{
    font-size:14px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(73,145,201,1) !important;
    line-height:25px;
  }
  .download-potential-download-text:hover,
  .download-potential-download-text:active,
  .download-potential-download-text:focus{
    color:rgba(27,85,131,1) !important;
    text-decoration: underline;
  }
  .download-potential-download-content{
    margin-bottom: 12px;
  }

  @media screen and (max-width:482px) {
    .download-potential-container{
      max-width: 100%;
    }
  }
  @media screen and (min-width:482px) and (max-width:768px) {
    .download-potential-container{
      max-width: 450px;
    }
  }
  @media screen and (min-width:768px) and (max-width:1100px) {
    .download-potential-container{
      max-width: 736px;
    }
  }
  @media screen and (min-width:1100px) and (max-width:1444px) {
    .download-potential-container{
      max-width: 1068px;
    }
  }
  @media screen and (min-width:1444px) {
    .download-potential-container{
      max-width: 1068px;
    }
  }

</style>
